import { ProductMetafields, ShopMetafields } from "~/types";
import { customBannerPDP } from "../../../settings/__product";

const SetupCustomBanner = ({ product, shop }: { product: ProductMetafields, shop: ShopMetafields}) => {
    const isMobile = window.innerWidth <= 1025
    
    return(
        <div className="custom-banner-product">
            <img src={isMobile ? customBannerPDP.mobile : customBannerPDP.src} alt="product banner" />
        </div>
    )

}

export default SetupCustomBanner;